module.exports = __webpack_public_path__ + "img/20190905155815117.cfe96047.jpg";